<template>
    <b-form @submit.stop.prevent="submitForm">
        <div v-for="field in Object.values(formFields)">
            <b-form-group
                :id="field.fieldid.toString()"
                :label="`${field.fieldcaption}${field.required === 'Y' ? '*' : ''}`"
                :label-for="field.fieldid.toString()"
                label-class="h6"
                v-if="field.fieldtype === 'textbox'"
            >
                <b-form-input
                    :id="field.fieldid.toString()"
                    v-model="formData[field.fieldid]"
                    trim
                    :required="field.required === 'Y'"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                :id="field.fieldid.toString()"
                :label="`${field.fieldcaption}${field.required === 'Y' ? '*' : ''}`"
                :label-for="field.fieldid.toString()"
                label-class="h6"
                v-if="field.fieldtype === 'multicheck'"
                :invalid-feedback="invalidFeedback(field.fieldid)"
                :state="state(field.fieldid)"
            >
                <b-form-checkbox-group
                    :id="field.fieldid.toString()"
                    v-model="formData[field.fieldid]"
                    :options="field.options"
                    stacked
                    @input="onMulticheckChange(field.fieldid)"
                ></b-form-checkbox-group>
            </b-form-group>

            <b-form-group
                :id="field.fieldid.toString()"
                :label="`${field.fieldcaption}${field.required === 'Y' ? '*' : ''}`"
                :label-for="field.fieldid.toString()"
                label-class="h6"
                v-if="field.fieldtype === 'option'"
            >
                <b-form-radio-group
                    :id="field.fieldid.toString()"
                    v-model="formData[field.fieldid]"
                    :required="field.required === 'Y'"
                    :options="field.options"
                ></b-form-radio-group>
            </b-form-group>

            <b-form-group
                :id="field.fieldid.toString()"
                label-class="h6"
                v-if="field.fieldtype === 'checkbox'"
            >
                <b-form-checkbox
                    :id="field.fieldid"
                    v-model="formData[field.fieldid]"
                    :name="field.fieldcaption"
                    value="Y"
                    unchecked-value="N"
                    plain
                    :required="field.required === 'Y'"
                >
                    {{`${field.fieldcaption}`}}
                    <a v-if="field.hasOwnProperty('isPrivacy')" class="text-secondary" rel="noopener noreferrer"
                       target="_blank" href="https://www.on24.com/privacy-policy/">privacy policy</a>
                    {{`${field.required === 'Y' ? '*' : ''}`}}
                </b-form-checkbox>
            </b-form-group>
        </div>
        <small class="text-bold">*{{trans('streams.dashboard.web_class_modal.cant_attend')}}</small>
        <div class="pb-4">
            <small>{{trans('streams.dashboard.web_class_modal.cant_attend_desc')}}</small>
        </div>
        <div class="d-flex justify-content-end w-100">
            <b-button class="btn-block-xs" type="submit" :disabled="loading">{{ trans('streams.dashboard.web_class_modal.cta') }}</b-button>
        </div>
    </b-form>
</template>

<script>
export default {
    name: "WebClassRegistration",
    props:{
        questions: Array,
        webClassId: String,
        sessionId: String,
    },
    data(){
        return{
            formData: {},
            formFields: {},
            loading: false,
            errors: [],
            formValid: false,
        }
    },
    methods:{
        convertRegisterData(){
            this.questions.map(field => {
                this.$set(this.formFields, field.fieldid, {...field});
                switch(field.fieldtype){
                    case 'multicheck':
                        let checkboxOptions = [];
                        field.options.map(checkbox => {
                            checkboxOptions.push({
                                text: checkbox,
                                value: checkbox
                            })
                        })
                        this.formFields[field.fieldid].options = checkboxOptions;
                        this.formFields[field.fieldid]['isMultiCheck'] = true;
                        this.formFields[field.fieldid]['isValid'] = false;
                        this.formFields[field.fieldid]['blur'] = false;
                        this.formData[field.fieldid] = [];
                        break;
                    case 'checkbox':
                        if(field.fieldcaption.includes("privacy policy")){
                            this.formFields[field.fieldid]['fieldcaption'] = field.fieldcaption.replace('privacy policy', '');
                            this.formFields[field.fieldid]['isPrivacy'] = true;
                        }
                        break;
                    case 'option':
                        let radioOptions = [];
                        field.options.map(radio => {
                            radioOptions.push({
                                text: radio,
                                value: radio
                            })
                        })
                        this.formFields[field.fieldid].options = radioOptions;
                        this.formData[field.fieldid] = [];
                        break;
                    default:
                        this.formData[field.fieldid] = '';
                        break;
                }
            })
        },
        submitForm(){
            this.loading = true;
            this.errors = [];
            this.formValid = true;
            let data = {...this.formData};

            Object.keys(data).map(key => {
                if (Array.isArray(data[key])) {
                    if(data[key].length === 0){
                        this.formFields[key].blur = true;
                        this.formValid = false;
                        this.loading = false;
                        this.$forceUpdate();
                    }else{
                        data[key] = data[key].join('|');
                    }
                }
            });

            if(this.formValid === true){
                this.$axios.post(`/api/rest/streams/${this.$route.params.id}/webClass/${this.webClassId}/${this.sessionId}/signup`, data)
                    .then(res => {
                        this.loading = false;
                        this.$emit('registrationComplete');
                        this.$bvModal.hide('web-class-modal')
                    })
                    .catch(err => {
                        console.log(err.response);
                        this.loading = false;
                    })
            }
        },
        invalidFeedback(fieldId) {
            if (this.formData[fieldId].length > 0) {
                return '';
            } else {
                return this.trans('webinars.registration.select_one');
            }
        },
        onMulticheckChange(fieldId){
            this.formFields[fieldId]['blur'] = true;
            this.formFields[fieldId]['isValid'] = this.formData[fieldId].length > 0;
            this.$forceUpdate();
        },
        state(fieldId) {
            return !this.formFields[fieldId]['isValid'] && this.formFields[fieldId]['blur'] ? false : null;
        },
    },
    mounted(){
        this.formFields = {};
        this.formData = {};
        this.convertRegisterData();
    },
}
</script>